import React from 'react'
import styles from './styles.css'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import { withRouter } from 'react-router'

@withMutation(gql`
  mutation updateDynamicSellNote($sellNoteId: ID, $formData: JSON) {
    updateDynamicSellNote(sellNoteId: $sellNoteId, formData: $formData) {
      success
    }
  }
`)
@withRouter
@withMessage
export default class Save extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    updateDynamicSellNote: PropTypes.func,
    operationData: PropTypes.object,
    formData: PropTypes.object,
    sellNoteId: PropTypes.string,
    preparationId: PropTypes.string
  }

  state = {}

  @autobind
  async save() {
    this.setState({ loading: true, errorMessages: null })
    const { sellNoteId, formData } = this.props
    try {
      await this.props.updateDynamicSellNote(
        { sellNoteId, formData },
        { refetchQueries: ['getDynamicSellNote'] }
      )
      this.props.showMessage('Datos guardados satisfactoriamente!')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  confirmExit() {
    const result = window.confirm(
      `Si sales sin guardar los datos se perderán. ¿Deseas continuar?`
    )
    if (!result) return
    const { preparationId } = this.props
    this.props.router.push(
      `/preparation/${preparationId}/dynamicSellNoteSelect`
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <Button onClick={() => this.confirmExit()}>Volver</Button>
        <Button primary onClick={this.save} loading={this.state.loading}>
          Guardar datos
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/Save/index.js